import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import SDModal from '@/shared/components/SDComponentsNewDesign/SDModal/SDModal'

import useDeleteModal from './useDeleteModal'
import { ModalActions, ModalText } from '../styled-components'

const DeleteModal = () => {
  const { isOpen, isDeleting, title, text, confirmLabel, cancelLabel, onOpenChange, cancel, confirm } = useDeleteModal()

  return (
    <SDModal
      isOpen={isOpen}
      openHandler={onOpenChange}
      title={title}
      sections={
        <>
          <ModalText>{text}</ModalText>
          <ModalActions>
            {/* @ts-expect-error SDButton is a JS component */}
            <SDButton id='fiscal-code-delete-cancel-btn' block={false} disabled={isDeleting} onClick={cancel}>
              {cancelLabel}
            </SDButton>
            {/* @ts-expect-error SDButton is a JS component */}
            <SDButton
              id='fiscal-code-delete-confirm-btn'
              block={false}
              disabled={isDeleting}
              isLoading={isDeleting}
              onClick={confirm}
            >
              {confirmLabel}
            </SDButton>
          </ModalActions>
        </>
      }
    />
  )
}

export default DeleteModal
